import React, { useState } from "react";
import Header from "./Header";
import DotsLog from "../img/DotsLog.svg";
import RightArow from "../img/RightArow.svg";

const Notifications = () => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => setShowDropdown((prev) => !prev);
  const handleShare = () => {
    setShowDropdown(false);
  };

  const handleInvoice = () => {
    setShowDropdown(false);
  };
  return (
    <div>
      <Header></Header>

      <div class="px-10" style={{ backgroundColor: "#FFFFFF" }}>
        <div class="flex justify-between mt-10 ">
          <h1 class="text-2xl font-semibold">Notification</h1>
          <span
            className="px-4 h-8 flex text-sm items-center rounded-lg text-white font-bold"
            style={{
              background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
            }}
          >
            Remove all
          </span>
        </div>

        <h1 class="text-lg mt-3">Apps that you are interested in.</h1>

        <div class="flex flex-col  mt-4 border p-2">
          <div class="w-full flex justify-between ">
            <div class="flex gap-2">
              <div class="flex flex-col justify-center">
                <span class="text-sm">Onzitr Marketplace</span>
                <span class="text-xs mt-2">Description </span>
                <span class="text-xs">Description </span>
              </div>
            </div>

            <span class="text-xs">1:22pm . 12 July 2024</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
